import "./index.css"
import { useState, useEffect } from "react";
import { HelmetProvider } from 'react-helmet-async';

import Image1 from "../../assets/Images/Home/founder.png"

import Graphic1 from "../../assets/Images/Elements/M-Orange.svg"
import Graphic2 from "../../assets/Images/Elements/Line.svg"

import Header from "../../assets/components/01_header/header"
import Footer from "../../assets/components/02_footer/footer"

import ServiceDashboardComponent from "../../assets/components/01_components/02_component/02_component"

import WhyChooseUs from "../../assets/components/01_components/01_component"

import BlogDashboardComponent from "../../assets/components/03_blogdashboard/blogdashboardcomponent";

import Marquee from "../../assets/components/01_components/03_component/03_component"

import SubSection from "../../assets/components/01_components/05_component/05_component"

import Testimonial from "../../assets/components/01_components/04_component/04_component"

import ContactComponent from "../../assets/components/08_contact_component/08_contact_component"

export default function Index() {
    return (
        <div>
            <HelmetProvider>
                <title>Adstrate</title>
                <meta name="Adstrate is a digital marketing agency in Mumbai delivering social media marketing in Mumbai, Instagram marketing agency services, and strategic content creation." />
                <link rel="canonical" href="https://adstrate.in/" />
            </HelmetProvider>
            <Header />
            <div className="Home-HeroSection">
                <img src={Graphic1} alt="" />
                <img src={Graphic2} alt="" />
                <h1>
                    Digital Marketing Agency in Mumbai Driving Growth and <span>Engagement</span>
                </h1>
                <a href="/quotation">Get Quote</a>
            </div>
            <Marquee />
            <WhyChooseUs />
            <SubSection />
            <ServiceDashboardComponent />
            <ContactComponent />
            <Footer />
        </div>
    );
}